var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "unified-task-page" },
    [
      _c(
        "div",
        { staticClass: "btn-list-box" },
        [
          _c(
            "Button",
            { attrs: { type: "error" }, on: { click: _vm.submit } },
            [_vm._v("查询")]
          ),
          _vm._v(" "),
          _c(
            "Button",
            { attrs: { type: "error", ghost: "" }, on: { click: _vm.reset } },
            [_vm._v("重置")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("FormLayout", {
        ref: "FormLayoutone",
        staticClass: "form-box",
        attrs: {
          defaultColumn: _vm.defaultColumn,
          defaultconfig: _vm.formConfig,
        },
      }),
      _vm._v(" "),
      _c("Page", {
        staticClass: "page-box",
        attrs: {
          current: _vm.pageNum,
          total: _vm.totalCount,
          "page-size-opts": _vm.pageSizeOpts,
          size: "small",
          "show-elevator": "",
          "show-sizer": "",
          "show-total": "",
        },
        on: {
          "on-change": _vm.pageChange,
          "on-page-size-change": _vm.pageSizeChange,
        },
      }),
      _vm._v(" "),
      _c("Table", {
        staticClass: "table-box",
        attrs: {
          border: "",
          columns: _vm.tableColumns,
          data: _vm.tableData,
          height: _vm.tableH,
          loading: _vm.loading,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }